import React from "react";
// import { NavLink } from "react-router-dom";

export default function Services() {

    return (
    <div style={{ marginTop: "4rem" }} className="img">
      <div className="row justify-content-center text-center">
        <div className="col-md-10 col-lg-8">
          <div className="header-section">
            <h2 className="display-6 text-center py-5 mb-4">
              Cyber Security <b> <span className="text-danger fw-bold blink">Training & Consultancy</span></b>
            </h2>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center my-4">
        <iframe
          width="1200"
          height="700"
          src="https://www.youtube.com/embed/TDo2YbJgA8I?si=kfUK4SN-H4OQxeMQ"
          title="YouTube video player"
          frameborder="2"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen>
        </iframe>
      </div>
    </div>
  );
}
